// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('sales.salestotal',{
        url: '/salestotal?{ps}&{pe}&{l}',
        views: {'wideColumnView@sales': {
            templateUrl: 'main/sales/salestotal/salestotal.tpl.html',
            controller: 'SalesTotalController as vm'
        }},
        resolve: {
            salesTotalsPagination: salesTotalPaginationResolver,
            locations: locationsResolver
        }
    });
}

// @ngInject
function salesTotalPaginationResolver(SalesApiService, $stateParams) {
    if (!$stateParams.ps) {
        $stateParams.ps = new Date().addDays(-30).getDatum();
    }
    if (!$stateParams.pe) {
        $stateParams.pe = new Date().getDatum();
    }
    if ($stateParams.l && $stateParams.l === '-1') {
        $stateParams.l = undefined;
    }
    return SalesApiService.getAllSalesTotals(
        {
            currentPage: 1,
            periodStart: $stateParams.ps,
            periodEnd: $stateParams.pe,
            itemsPerPage: 20,
            status: ['forReview']
        });
}

// @ngInject
function locationsResolver(LocationsApiService) {
    return LocationsApiService.listAll({ locationTypes: ['onlinestore','store'], isActive: true });
}

Date.prototype.addDays = function(days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};
Date.prototype.getDatum = function() {
    var dat = new Date(this.valueOf());
    var month = dat.getMonth() + 1;
    if (month < 10) { month = '0' + month; }
    var date = dat.getDate();
    if (date < 10) { date = '0' + date; }
    var str = dat.getFullYear() + '-' + month + '-' + date;
    return str;
};

// @ngInject
function SalesTotalController($state, $stateParams, $scope, $translate, salesTotalsPagination, locations,
    SalesApiService, loadSpinnerService, ToasterService, salesTotalFilterDialogService) {
    var vm = this;

    //Properties
    vm.salesTotals = salesTotalsPagination !== undefined &&
        salesTotalsPagination.data !== undefined &&
        salesTotalsPagination.data.saleTotals.results !== undefined ?
        salesTotalsPagination.data.saleTotals.results :
        {};
    _.forEach(vm.salesTotals, function(s) { s.showRows = false; });
    vm.pageSize = salesTotalsPagination !== undefined &&
        salesTotalsPagination.data !== undefined ?
        salesTotalsPagination.data.saleTotals.limit :
        20;
    vm.currentPage = salesTotalsPagination !== undefined &&
        salesTotalsPagination.data !== undefined ?
        salesTotalsPagination.data.saleTotals.page :
        1;
    vm.totalItems = salesTotalsPagination !== undefined &&
        salesTotalsPagination.data !== undefined ?
        salesTotalsPagination.data.saleTotals.total :
        0;
    vm.locations = locations;
    _.forEach(vm.locations, function(l) {
        return l.locationName = l.locationNumber + ' ' + l.locationName;
    });
    vm.selectedLocation = {};

    vm.periodStartDate = $stateParams.ps ? new Date($stateParams.ps) : new Date().addDays(-30);
    vm.periodEndDate = $stateParams.pe ? new Date($stateParams.pe) : new Date();
    vm.shownStatuses = ['forReview'];
    vm.includeApproved = false;
    vm.includeForProcessing = false;
    vm.includeForReview = true;

    //Methods
    vm.toggleApproved = toggleApproved;
    vm.toggleForProcessing = toggleForProcessing;
    vm.toggleForReview = toggleForReview;
    vm.getSaleTotals = getSaleTotals;
    vm.getPaymentTotals = getPaymentTotals;
    vm.toggleRows = toggleRows;
    vm.approveSalesTotal = approveSalesTotal;
    vm.getPeriodPaymentSum = getPeriodPaymentSum;
    vm.getCalculatedPaymentSum = getCalculatedPaymentSum;
    vm.getSaleVatAmountSum = getSaleVatAmountSum;
    vm.getCalculatedVatAmountSum = getCalculatedVatAmountSum;
    vm.getTotalNetAmountSum = getTotalNetAmountSum;
    vm.getTotalVatAmountSum = getTotalVatAmountSum;
    vm.approveSalesTotal = approveSalesTotal;
    vm.viewApprovedButton = viewApprovedButton;
    vm.getStatusString = getStatusString;
    vm.getSaleNetAmountSum = getSaleNetAmountSum;
    vm.getCalculatedNetAmountSum = getCalculatedNetAmountSum;
    vm.showConfirmButton = showConfirmButton;
    vm.showRedSaleDiff = showRedSaleDiff;
    vm.showRedCalculatedDiff = showRedCalculatedDiff;
    vm.totalSaleDiff = totalSaleDiff;
    vm.totalCalculatedDiff = totalCalculatedDiff;
    vm.roundToTwo = roundToTwo;
    vm.showTotalDiffTable = showTotalDiffTable;
    vm.getSalesNumberSum = getSalesNumberSum;
    vm.getNetAmount = getNetAmount;
    vm.abs = Math.abs;
    vm.showFilterDialog = showFilterDialog;

    activate();

    function activate() {
        $scope.$watch(function() { return vm.currentPage; }, function(newValue, oldValue) {
            if (newValue !== null && newValue !== oldValue) {
                loadSaleTotals();
            }
        });
        compileShownStatuses();

        if ($stateParams.l) {
            vm.selectedLocation = _.find(vm.locations, function (o) { return '' + o.id === $stateParams.l; });
            if (!vm.selectedLocation) { vm.selectedLocation = {}; }
            if (vm.selectedLocation.id) {
                loadSaleTotals();
            }
        }
    }

    function showFilterDialog() {
        salesTotalFilterDialogService
            .showDialog(
                vm.periodStartDate,
                vm.periodEndDate,
                vm.locations,
                vm.selectedLocation,
                vm.includeApproved,
                vm.includeForProcessing
            )
            .then(function(response) {
                if (response.confirmation) {
                    var reloadRows = false;
                    var refilter = false;

                    if (!isSameDate(vm.periodStartDate, response.periodStartDate)) {
                        vm.periodStartDate = response.periodStartDate;
                        reloadRows = true;
                    }

                    if (!isSameDate(vm.periodEndDate, response.periodEndDate)) {
                        vm.periodEndDate = response.periodEndDate;
                        reloadRows = true;
                    }
                    if (vm.selectedLocation === undefined || vm.selectedLocation.id === undefined || vm.selectedLocation.id !== response.selectedLocation) {
                        vm.selectedLocation = _.find(vm.locations, function(o) { return o.id === response.selectedLocation; });
                        reloadRows = true;
                    }
                    if (vm.includeApproved !== response.includeApproved) {
                        vm.includeApproved = response.includeApproved;
                        refilter = true;
                    }
                    if (vm.includeForProcessing !== response.includeForProcessing) {
                        vm.includeForProcessing = response.includeForProcessing;
                        refilter = true;
                    }

                    if (reloadRows) {
                        $state.go('sales.salestotal', {
                            ps: new Date(vm.periodStartDate).getDatum(),
                            pe: new Date(vm.periodEndDate).getDatum(),
                            page: vm.currentPage,
                            l: vm.selectedLocation ? vm.selectedLocation.id : undefined
                        });
                    }
                    if (refilter === true) {
                        compileShownStatuses();
                        loadSaleTotals();
                    }
                }
            });
    }

    function isSameDate(newValue, oldValue) {
        if (newValue === undefined || newValue === null) { return false; }
        if (oldValue === undefined || oldValue === null) { return false; }

        newValue = new Date(newValue);
        oldValue = new Date(oldValue);
        var newYear = newValue.getFullYear();
        var newMonth = newValue.getMonth();
        var newDay = newValue.getDate();
        var oldYear = oldValue.getFullYear();
        var oldMonth = oldValue.getMonth();
        var oldDay = oldValue.getDate();

        if (newYear !== oldYear) { return false; }
        if (newMonth !== oldMonth) { return false; }
        if (newDay !== oldDay) { return false; }

        return true;
    }

    function toggleApproved() {
        vm.includeApproved = !vm.includeApproved;
        compileShownStatuses();
        loadSaleTotals();
    }
    function toggleForProcessing() {
        vm.includeForProcessing = !vm.includeForProcessing;
        compileShownStatuses();
        loadSaleTotals();
    }
    function toggleForReview() {
        vm.includeForReview = !vm.includeForReview;
        compileShownStatuses();
        loadSaleTotals();
    }
    function compileShownStatuses() {
        vm.shownStatuses = [];
        if (vm.includeApproved) {
            vm.shownStatuses.push('approved');
            vm.shownStatuses.push('autoApproved');
        }
        if (vm.includeForProcessing) {
            vm.shownStatuses.push('forProcessing');
        }
        if (vm.includeForReview) {
            vm.shownStatuses.push('forReview');
        }
    }

    function loadSaleTotals() {
        //ForProcessing, Approved, ForReview
        loadSpinnerService.start('mainSpinner');
        SalesApiService.getAllSalesTotals({ currentPage: vm.currentPage, itemsPerPage: vm.pageSize, periodStart: vm.periodStartDate, periodEnd: vm.periodEndDate, locationId: vm.selectedLocation.id, status: vm.shownStatuses }).then(function(response) {
            vm.salesTotals = response !== undefined &&
                response.data !== undefined &&
                response.data.saleTotals.results !== undefined ?
                response.data.saleTotals.results :
                {};
            vm.pageSize = response !== undefined &&
                response.data !== undefined ?
                response.data.saleTotals.limit :
                20;
            vm.currentPage = response !== undefined &&
                response.data !== undefined ?
                response.data.saleTotals.page :
                1;
            vm.totalItems = response !== undefined &&
                response.data !== undefined ?
                response.data.saleTotals.total :
                0;
            _.forEach(vm.salesTotals, function(s) { s.showRows = false; });
        }, function (error) {
            //console.log(error);
            ToasterService.showError(error, $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getStatusString(status) {
        switch (status.toLowerCase()) {
            case 'approved':
                return $translate.instant('salestotal.statusApproved');
            case 'autoapproved':
                return $translate.instant('salestotal.statusAutoApproved');
            case 'forprocessing':
                return $translate.instant('salestotal.statusForProcessing');
            default:
                return '';
        }
    }

    function getSaleTotals(currentSaleTotal) {
        var totalSales = _.sumBy(currentSaleTotal.saleTotals, function(s) { return s.calculatedNetAmount - s.calculatedVatAmount; });
        var withdrawals = currentSaleTotal.withdrawalAmount;
        var deposits = currentSaleTotal.depositAmount;
        var total = totalSales + (withdrawals - deposits);
        return total;
    }

    function getPaymentTotals(currentSaleTotal) {
        var totalPayments = _.sumBy(currentSaleTotal.paymentTotals, function(s) { return s.calculatedAmount; });
        return totalPayments;
    }

    function toggleRows(salesTotal) {
        if (salesTotal.showRows === undefined) { salesTotal.showRows = false; return false; }
        salesTotal.showRows = !salesTotal.showRows;
    }

    function approveSalesTotal(salesTotal) {
        loadSpinnerService.start('mainSpinner');
        SalesApiService.approveSalesTotal(salesTotal.id).then(function(response) {
            loadSaleTotals();
        }, function (error) {
            //console.log(error);
            ToasterService.showError(error, $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function viewApprovedButton() {
        return true;
    }

    function getSalesNumberSum(saleTotals) {
        var sum = 0;

        if (saleTotals && saleTotals.length > 0) { sum = saleTotals[0].calculatedNumberOfSales; }

        return sum;
    }
    function getPeriodPaymentSum(paymentTotals) {
        var sum = _.sumBy(paymentTotals, function(s) { return s.amount - s.negativeAmount; });
        return sum;
    }
    function getCalculatedPaymentSum(paymentTotals) {
        var sum = _.sumBy(paymentTotals, function(s) { return s.calculatedAmount; });
        return sum;
    }

    function getSaleVatAmountSum(saleTotals) {
        var sum = _.sumBy(saleTotals, function(s) { return s.vatAmount - s.negativeVatAmount; });
        return sum;
    }
    function getCalculatedVatAmountSum(saleTotals) {
        var sum = _.sumBy(saleTotals, function(s) { return s.calculatedVatAmount; });
        return sum;
    }

    function getTotalNetAmountSum(saleTotals) {
        var sum = _.sumBy(saleTotals, function(s) { return (s.netAmount - s.negativeNetAmount) + (s.vatAmount - s.negativeVatAmount); });
        return sum;
    }
    function getTotalVatAmountSum(saleTotals) {
        var sum = _.sumBy(saleTotals, function(s) { return (s.calculatedNetAmount - s.calculatedVatAmount); });
        return sum;
    }

    function getSaleNetAmountSum(salesTotal) {
        var saleTotals = salesTotal.saleTotals;
        var sum = _.sumBy(saleTotals, function(s) { return getNetAmount(salesTotal, s); });
        return sum;
    }
    function getCalculatedNetAmountSum(saleTotals) {
        var sum = _.sumBy(saleTotals, function(s) { return s.calculatedNetAmount; });
        return sum;
    }
    function showConfirmButton(salesTotal) {
        if (!salesTotal || !salesTotal.links || salesTotal.links.length === 0) {
            return false;
        }

        var link = _.find(salesTotal.links, function (o) { return o.rel === 'approve'; });
        if (link) {
            return true;
        } else {
            return false;
        }
    }

    function showRedSaleDiff(salesTotal) {
        var temp1 = vm.getSaleNetAmountSum(salesTotal) + vm.getSaleVatAmountSum(salesTotal.saleTotals);
        var temp2 = vm.getPeriodPaymentSum(salesTotal.paymentTotals);

        if (Math.abs(roundToTwo(temp2)) === 0.00) { return true; }
        if (Math.abs(roundToTwo(temp1 - temp2)) !== 0.00) { return true; }
        return false;
    }
    function showRedCalculatedDiff(salesTotal) {
        var temp1 = vm.getCalculatedNetAmountSum(salesTotal.saleTotals) + vm.getCalculatedVatAmountSum(salesTotal.saleTotals);
        var temp2 = vm.getCalculatedPaymentSum(salesTotal.paymentTotals);

        if (Math.abs(roundToTwo(temp2)) === 0.00) { return true; }
        if (Math.abs(roundToTwo(temp1 - temp2)) !== 0.00) { return true; }
        return false;
    }

    function roundToTwo(number) {
        var precision = 2;
        var shift = function (number, precision, reverseShift) {
          if (reverseShift) {
            precision = -precision;
          }
          var numArray = ('' + number).split("e");
          return +(numArray[0] + "e" + (numArray[1] ? (+numArray[1] + precision) : precision));
        };

        var result = shift(Math.round(shift(number, precision, false)), precision, true);
        if (result === 0) { return '0.00'; }
        return result.toFixed(2);
    }

    function showTotalDiffTable(salesTotal) {
        var temp1 = (vm.getSaleNetAmountSum(salesTotal.saleTotals) + vm.getSaleVatAmountSum(salesTotal.saleTotals));
        var temp2 = vm.getPeriodPaymentSum(salesTotal.paymentTotals);
        var temp3 = (vm.getCalculatedNetAmountSum(salesTotal.saleTotals) + vm.getCalculatedVatAmountSum(salesTotal.saleTotals));
        var temp4 = vm.getCalculatedPaymentSum(salesTotal.paymentTotals);

        if (roundToTwo(temp1 - temp2) !== '0.00' ||
            roundToTwo(temp3 - temp4) !== '0.00') {
            return true;
        } else {
            return false;
        }
    }

    function totalSaleDiff(salesTotal) {
        var temp1 = (vm.getSaleNetAmountSum(salesTotal) + vm.getSaleVatAmountSum(salesTotal.saleTotals));
        var temp2 = vm.getPeriodPaymentSum(salesTotal.paymentTotals);

        return (temp2 - temp1);
    }
    function totalCalculatedDiff(salesTotal) {
        var temp1 = (vm.getCalculatedNetAmountSum(salesTotal.saleTotals) + vm.getCalculatedVatAmountSum(salesTotal.saleTotals));
        var temp2 = vm.getCalculatedPaymentSum(salesTotal.paymentTotals);

        return (temp2 - temp1);
    }

    function getNetAmount(salesTotal, saleTotal) {
        if (saleTotal.vatRate === 0) {
            return saleTotal.netAmount - saleTotal.negativeNetAmount + salesTotal.withdrawalAmount;
        }

        return saleTotal.netAmount - saleTotal.negativeNetAmount;
    }
}

angular
    .module('sales.salestotal', [])
    .config(stateConfig)
    .controller('SalesTotalController', SalesTotalController);
